import React from "react";

import { useHistory } from "react-router-dom";
import { Button, Result } from "antd";
import isConsultant from "../services/isConsultant";

const FeedbackAlreadySubmitAlert = () => {
    const history = useHistory();
  return (
    <div>
      {/* <img
        style={{
          backgroundSize: "auto",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate",
          transform: "translate(-50%,-50%)",
          width: "43rem",
        }}
        src={errorImg}
      /> */}
      <Result
        status="404"
        title="Sorry, You have already submitted the Feedback."
       // subTitle="Sorry, You have already submitted the Feedback."
        //extra={<Button onClick={() => history.goBack()} type="primary">Back Home</Button>}
      />
    </div>
  );
};

export default FeedbackAlreadySubmitAlert;
